<template>
    <div class='body-box marginBox'>
        <!-- 搜索与添加区域 -->
        <el-row class="plan selectBox" :gutter="24">
            <el-col :span='8'>
                <el-button @click='addCoupon("新增优惠券")'>新增</el-button>
                <el-button @click='updateCoupon("修改优惠券")'>修改</el-button>
                <el-button @click='delCoupon("batch")'>批量删除</el-button>
            </el-col>

            <el-col :span='4'>
                <search-input v-model="search.nameId" placeholder="请输入优惠券名称/ID搜索" @change="handleQuery" />
            </el-col>

            <el-col :span='4'>
                <search-input v-model="search.couponPrice" type="number" placeholder="请输入优惠券面额搜索" @change="handleQuery" />
            </el-col>

            <el-col :span='4'>
                <el-select v-model="search.applicableProduct" clearable placeholder="选择优惠券适用产品进行筛选" @change="handleQuery">
                    <el-option
                            v-for="item in enumApplicableProduct"
                            :key="item.id"
                            :label="item.label"
                            :value="item.value"
                    >
                    </el-option>
                </el-select>
            </el-col>

            <el-col :span='4'>
                <el-select v-model="search.applicableTarget" clearable placeholder="选择优惠券适用对象进行筛选" @change="handleQuery">
                    <el-option
                            v-for="item in enumApplicableTarget"
                            :key="item.id"
                            :label="item.label"
                            :value="item.value"
                    >
                    </el-option>
                </el-select>
            </el-col>
        </el-row>

        <el-table :height="'calc(100% - 70px)'" :data='couponList' class='button-box' ref="couponList">
            <el-table-column
                    type="selection"
                    width="55">
            </el-table-column>
            <el-table-column label='优惠券ID' prop='id' />
            <el-table-column label='优惠券名称' prop='couponName' />
            <el-table-column label='适用产品' prop='applicableProduct'>
                <template slot-scope="scope">
                    {{statusChange(scope.row.applicableProduct)}}
                </template>
            </el-table-column>
            <el-table-column label='优惠券面额' prop='couponPrice'/>
            <el-table-column label='适用有效期' prop='endTime'>
                <template slot-scope="scope">
                    {{validity(scope.row)}}
                </template>
            </el-table-column>
            <el-table-column label='优惠券类型' prop='couponType'>
                <template slot-scope="scope">
                    {{statusChange(scope.row.couponType)}}
                </template>
            </el-table-column>
            <el-table-column label='适用对象' prop='applicableTarget'>
                <template slot-scope="scope">
                    {{statusChange(scope.row.applicableTarget)}}
                </template>
            </el-table-column>
            <el-table-column label='操作'>
                <template slot-scope="scope">
                    <el-button @click='updateCoupon("修改优惠券",scope.row)'>修改</el-button>
                    <el-button @click='delCoupon(scope.row)'>删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <!-- 分页区域 -->
        <div class="fixedBox"><pagination ref='page' :query-param.sync='queryInfo' @pagination='getCouponList' /></div>
        <editCoupon ref="editCoupon" @refresh-list="handleQuery"></editCoupon>
    </div>
</template>

<script>

  import SearchInput from '@/components/common/searchInput/searchInput'
  import Pagination from '@/components/common/Pagination/index'
  import { getCouponsByType, delCoupon, isUseCoupon } from '@/api/coupon/coupon'
  import { isRestaurantCoupon } from '@/api/restaurant/restaurant'
  import editCoupon from '@/views/coupon/editCoupon'
  import { alert, deleteTips, tips } from '@/utils/tips'
  import { formatDate } from '@/js/momen'
  import { enumStatus, enumApplicableProduct, enumApplicableTarget } from '@/js/enum'

  export default {
    name: 'coupon',
    components: { editCoupon, SearchInput, Pagination },
    data() {
      return {
        // 查询参数
        queryInfo: {},
        search: {},
        couponList: [],
        enumApplicableTarget,
        enumApplicableProduct,
      }
    },
    created() {
      this.handleQuery()
    },
    mounted() {
    },
    methods: {
      // 状态码转换
      statusChange(p){
        let text = ''
        enumStatus.forEach(res => {
          if (p === res.key) {
            text = res.value
          }
        })
        return text
      },
      validity(row) {
        return row?.couponType === 'TIME' ? formatDate(row.endTime,"yyyy-MM-dd hh:mm:ss") : '发放后' + row.effectiveDay + '天到期'
      },
      handleQuery() {
        this.$nextTick(() => {
          this.$refs.page.run()
        })
      },
      // 新增优惠券
      addCoupon(title) {
        this.$refs.editCoupon.showDialog(title)
      },
      // 修改优惠券
      updateCoupon(title, row) {
        let data = {}
        if (row) { // 如果是单行选择
          data = row
        } else {
          let list = this.$refs.couponList.selection
          if (list.length !== 1) {
            alert("只能选中单行时才能进行修改！","提示")
            return
          }
          data = list[0]
        }
        // 判断用户是否使用
        isUseCoupon(data.id).then(res => {
          if (res.data.length > 0) {
            alert("该优惠券还有用户使用，不允许进行修改，建议新增优惠券！","提示")
            return
          } else {
            // 判断是否有饭店使用，只有饭店使用时可进行更改，需要确认
            isRestaurantCoupon(data.id).then(res => {
              if (res.data > 0) {
                tips("该优惠券没有用户使用，但在饭店正在使用，是否进行修改？").then(res => {
                  if (res) {
                    this.$refs.editCoupon.showDialog(title,data)
                  }
                })
              } else {
                this.$refs.editCoupon.showDialog(title,data)
              }
            })
          }
        })
      },
      async delCoupon(row) {
        let list = []
        if (row !== "batch") {
          list = [row.id]
        } else {
          list = this.$refs.couponList.selection
          if (list.length <= 0) {
            await alert("至少选择一行！","提示")
            return
          }
          list = list.map(res => res.id)
        }
        let b = await deleteTips("确认删除吗？")
        if (b) {
            // 先看看是不是已经没有人使用了
            isUseCoupon(list.join(",")).then(res => {
              let isUse = res.data
              if (isUse.length > 0) {
                if (list.length === 1) {
                  alert("该优惠券还有用户使用，不能删除！","提示")
                } else {
                  alert(isUse.join(",") + "还有用户使用，其余可删除优惠券已删除！","提示")
                }
              }
              // 删除
              isUse.forEach(res => list.remove(res))
              if (list.length > 0) {
                let ids = list.join(",")
                delCoupon(ids).then(() => {
                  this.handleQuery()
                })
              }
            })
        }
      },
      // 查看优惠券
      getCouponList(data,cb) {
        getCouponsByType(data, this.search).then(res => {
          this.couponList = cb(res)
        })
      },
    }
  }
</script>

<style lang="less" scoped>

</style>